import { CourseConstants as Constants } from "../constants";
import { courseApi as api } from "../../api";

export const courseAction = {
  get,
  list,
  add,
  import_questions,
  details,
  update,
  remove,
  clear,
  course_details,
};

function get() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.GET, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function list() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._list().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.LIST, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function import_questions(form_data, course_id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._import_questions(form_data, course_id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DETAILS, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function details(slug) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._details(slug).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DETAILS, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function add(form_data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._add(form_data).then(
        (payload) => {
          dispatch(success(payload));
          resolve();
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
    function success(payload) {
      return { type: Constants.ADD, payload };
    }
    function failure() {
      return { type: Constants.FAILED };
    }
  };
}

function update(form_data, id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._update(form_data, id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.UPDATE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function remove(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._delete(id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DELETE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function clear() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(success());
      resolve();
    });
  };
  function success() {
    return { type: Constants.CLEAR };
  }
}

function course_details(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api.course_details(id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.COURSE_DETAILS, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}
